import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faHouse,
  faListCheck,
  faIndustry,
  faListUl,
  faPen,
  faArrowsLeftRight,
  faHammer,
  faScaleBalanced,
  faTriangleExclamation,
  faExplosion,
  faBomb,
  faDroplet,
  faMountain,
  faCubesStacked,
  faCubes,
  faGears,
  faFileLines,
  faSun,
  faBook,
  faScrewdriverWrench,
  faPlug,
  faCoins,
  faMoneyBill,
  faBullseye,
  faFileImport,
  faGear,
  faUsers,
  faDatabase,
  faCircleDot,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";

const ROUTE_ICONS: Record<string, IconDefinition> = {
  "/": faHouse,

  "/operations": faListCheck,

  "/production": faIndustry,
  "/production/show": faPen,
  "/production/list": faListUl,
  "/production/rehandle": faArrowsLeftRight,
  "/production/crushing": faHammer,
  "/production/ore-tally": faScaleBalanced,

  "/stoppages": faTriangleExclamation,

  "/machine-positions": faLocationDot,

  "/db": faExplosion,
  "/db/bh-drilling": faPen,
  "/db/bh-drilling-list": faListUl,
  "/db/blasts": faBomb,
  "/db/dewatering": faDroplet,

  "/geology": faMountain,
  "/geology/production": faPen,
  "/geology/mining-movements": faMountain,
  "/geology/stockpile-balances": faCubesStacked,
  "/geology/ore-blocks": faCubes,
  "/geology/ore-tally": faScaleBalanced,
  "/geology/milling": faGears,
  "/geology/drilling": faHammer,

  "/reports": faFileLines,
  "/reports/daily": faFileLines,
  "/reports/morning": faSun,
  "/reports/library": faBook,
  "/reports/builder": faScrewdriverWrench,
  "/reports/data-connections": faPlug,

  "/royalty-fees": faMoneyBill,
  "/royalty-area-balances": faCoins,

  "/targets": faBullseye,
  "/targets/imports": faFileImport,

  "/admin": faGear,
  "/admin/users": faUsers,
  "/admin/references": faDatabase,
};

export const DEFAULT_ROUTE_ICON: IconDefinition = faCircleDot;

export function getRouteIcon(fullPath: string): IconDefinition {
  return ROUTE_ICONS[fullPath] ?? DEFAULT_ROUTE_ICON;
}

export default ROUTE_ICONS;
